import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import AtlasPriceIndexSplineChart from 'src/components/AtlasV2Components/AtlasPriceV2PageComponents/AtlasPriceIndexSplineChart';
import AtlasPriceTopEntityChart from 'src/components/AtlasV2Components/AtlasPriceV2PageComponents/AtlasPriceTopEntityChart';
import { AtlasSalesV2ProductGrid } from 'src/components/AtlasV2Components/AtlasSalesV2PageComponents/AtlasSalesV2ProductGrid';
import { DorisMetricTypeEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Atlas V2 Price Summary Page layout - Tab name: prices subtab name: retailPrice
 */
export const AtlasPriceSummaryV2PageLayout = () => {
  const { isAllCategoriesEntity } = useCategoryEntity();
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider group={CHART_CONTEXT_GROUPS.PRICE_RETAIL_PRICE} chartName={CHART_NAMES.PRICE_RETAIL_PRICE_SPLINE}>
          <AtlasV2DorisSplineChart
            queryKey="retailPriceSplineChart"
            title="Retail Price"
            showAverageRate
            methodName="sales/GetSalesMetrics"
            metricTypeDisplay={METRICTYPE.MONEY}
            metricType="RetailPrice"
          />
        </ChartContextProvider>

        {!isAllCategoriesEntity && (
          <ChartContextProvider group={CHART_CONTEXT_GROUPS.PRICE_INDEX} chartName={CHART_NAMES.PRICE_INDEX_SPLINE}>
            <AtlasPriceIndexSplineChart />
          </ChartContextProvider>
        )}

        {!isProductEntity && (
          <ChartContextProvider group={CHART_CONTEXT_GROUPS.PRICE_TOP_ENTITY} chartName={CHART_NAMES.PRICE_TOP_ENTITY_COLUMN}>
            <AtlasPriceTopEntityChart />
          </ChartContextProvider>
        )}

        <AtlasSalesV2ProductGrid salesType={DorisMetricTypeEnum.RetailPrice} />
      </Flex>
    </BasePageContainer>
  );
};
